import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  TYFCB_EDIT,
  TYFCB_UPDATE,
  USER_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { TYFCB_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from "../../components/common/Loader";

const TyfcbEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userOptions, setUserOptions] = useState([]);

  const businessTypeOptions = [
    { value: 1, label: "New" },
    { value: 2, label: "Repeat" },
  ];
  const referralTypeOptions = [
    { value: 1, label: "Inside" },
    { value: 2, label: "Outside" },
  ];

  const submit = () => {
    if (form.from_user_id && Number(form.from_user_id) === Number(form.to_user_id)) {
      toast.error("Receiver and giver cannot be the same");
      return;
    }
    if (!form.amount || Number(form.amount) <= 0) {
      toast.error("Amount must be greater than 0");
      return;
    }
    setLoading(true);
    setBtnDisabled(true);
    axios
      .put(TYFCB_UPDATE + id, {
        to_user_id: form.to_user_id,
        amount: Number(form.amount),
        business_type: form.business_type,
        referral_type: form.referral_type,
        comments: form.comments,
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(TYFCB_UPDATED);
          navigate("/tyfcbs");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        } else if (err.response?.data?.msg) {
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    axios
      .get(TYFCB_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const d = res.data.data;
          setForm({
            from_user_id: d.from_user_id,
            to_user_id: d.to_user_id,
            to_user_selected: d.to_user_id
              ? { value: Number(d.to_user_id), label: d.to_user_name }
              : null,
            amount: d.amount || "",
            business_type: d.business_type,
            business_type_selected:
              businessTypeOptions.find(
                (o) => o.value === Number(d.business_type),
              ) || null,
            referral_type: d.referral_type,
            referral_type_selected:
              referralTypeOptions.find(
                (o) => o.value === Number(d.referral_type),
              ) || null,
            comments: d.comments || "",
            chapter_id: d.chapter_id,
            from_user_name: d.from_user_name || "",
          });
        }
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (form.chapter_id == null) return;
    axios
      .get(USER_LIST_DROPDOWN, {
        params: {
          chapter_id: form.chapter_id,
          exclude_other_region_chapter_users: 1,
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const options = res.data.data || [];
          const filteredOptions = form.from_user_id
            ? options.filter((u) => Number(u.value) !== Number(form.from_user_id))
            : options;
          setUserOptions(filteredOptions);
        }
      });
  }, [form.chapter_id, form.from_user_id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">TYNs</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/tyfcbs"}>
                    <span>TYNs List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit TYN</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/tyfcbs"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                       <div className="mb-3">
                        <label className="form-label m-0">Receiver</label>
                        <p className="mb-0"> {form.from_user_name || "-"}</p>
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label" htmlFor="from_user_name">
                          Receiver
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="from_user_name"
                          value={form.from_user_name || ""}
                          disabled
                        />
                      </div> */}
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label m-0">Giver</label>
                        <p className="mb-0"> {form.to_user_selected?.label || "-"}</p>
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label" htmlFor="to_user_id">
                          Giver<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="to_user_id"
                          options={userOptions}
                          placeholder="Select Member"
                          value={form.to_user_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              to_user_id: selected?.value,
                              to_user_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="to_user_id" />
                      </div> */}
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="amount">
                          Amount<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="amount"
                          placeholder="Amount"
                          min="1"
                          value={form.amount || ""}
                          onChange={(e) =>
                            setForm({ ...form, amount: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="amount" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="business_type">
                          Business Type<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="business_type"
                          options={businessTypeOptions}
                          placeholder="Select"
                          value={form.business_type_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              business_type: selected?.value,
                              business_type_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="business_type" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="referral_type">
                          Referral Type<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="referral_type"
                          options={referralTypeOptions}
                          placeholder="Select"
                          value={form.referral_type_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              referral_type: selected?.value,
                              referral_type_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="referral_type" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="comments">
                          Comments<span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          id="comments"
                          placeholder="Comments"
                          rows={3}
                          value={form.comments || ""}
                          onChange={(e) =>
                            setForm({ ...form, comments: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="comments" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/tyfcbs"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TyfcbEdit;
